// @vendors
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
const { Map, List } = require('immutable');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { PROC_BROKER_ORDERS_AND_MOVEMENTS } = require('utilities/tagging.js');
const { taggingEventHandled } = require('../../../utilities/taggingEventHandled');
const { addCryptoContracts } = require('../../../utilities/cryptoHelper');

// @commons
const { TabbedContentBox } = require('commonsComponents/tabbedContentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

// @components
const AccountLastMovements = require('components/accounts/accountLastMovements/accountLastMovements');
const BrokerOrdersAndMovementsConsult = require('components/broker/brokerOrdersAndMovementsConsult/brokerOrdersAndMovementsConsult');
const BrokerOrdersAndMovementsActivity = require('components/broker/brokerOrdersAndMovementsActivity/brokerOrdersAndMovementsActivity');
const BrokerOrdersAndMovementsMovementsTab = require('components/broker/brokerOrdersAndMovementsMovementsTab/brokerOrdersAndMovementsMovementsTab');
const BrokerOrdersAndMovementsNewView = require('components/broker/brokerOrderAndMovementsNewView/brokerOrdersAndMovementsNewView');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const {
    getContractActivities,
    getNewFundMovements,
    getRejectedActivities,
    setFilter: setActivityFilter,
    clearFilter: clearActivityFilter
} = require('actions/brokerContractActivities');
const {
    getValueMovements,
    setFilter: setMovementsFilter,
    clearFilter: clearMovementsFilter
} = require('actions/brokerValueMovements');
const brokerValueMovementsActions = require('actions/brokerValueMovements');
const { getAllContractValues, applyCryptoFilter, clearCryptoFilters } = require('actions/brokerContractValues');
const { getAllCryptoContractValues } = require('actions/brokerContractValues');
const { selectedOptionChanged, reset } = require('actions/brokerOrdersAndMovements');
const { fetchMyInvestments } = require('actions/brokerMyInvestments');
const accountsTransactionsActions = require('actions/getAccountsTransactions');
const accountTransactionsDownloadActions = require('actions/accountTransactionsDownload');
const signaturePatternActions = require('actions/signaturePattern');
const brokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');

// @constants
const {
    BROKER_JOINT_CONTRACTS_VALUE,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
    BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
    BROKER_JOINT_CONTRACTS_FUTURES,
    BROKER_JOINT_CONTRACTS_FUND,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_NEW_VERSION_VIEW,
    BROKER_JOINT_CONTRACTS_CRYPTO,
} = require('constants/index');
const { INVESTMENT_CONTRACTS_CANCELLED } = require('constants/flagBasedFeatures');

class BrokerOrdersAndMovementsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedContract: null,
            selectedOption: null
        };

        this.setSelectedContract = this.setSelectedContract.bind(this);
        this.setSelectedOption = this.setSelectedOption.bind(this);
    }

    componentDidMount() {
        const { flagBasedFeatures } = this.props;

        flagBasedFeatures.get(INVESTMENT_CONTRACTS_CANCELLED) && this.props.fetchContractList();
        this.props.fetchMyInvestments();
        window.utag && window.utag && window.utag.view && window.utag.view({
            event_name: "view",
            pageName: "/broker/orders-and-movements",
            serviceType: "productInformation",
            interactionType: "screen",
            })
    }

    componentWillUnmount() {
        this.props.clearFilter();
        this.props.reset();
    }

    getBreadcrumbData() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-ordersAndMovements')
            }
        ];
    }

    setSelectedContract(selectedContract) {
        const { immJointContracts, requestAccountTransactions } = this.props;
        const contractType = immJointContracts.getIn(['byId', selectedContract, 'type']);
        if (contractType === BROKER_JOINT_CONTRACTS_FUTURES) {
            const accountId = immJointContracts.getIn(['byId', selectedContract, 'accountId']);
            requestAccountTransactions(accountId);
        }
        this.setState({
            selectedContract,
            selectedOption: null
        });
        taggingEventHandled(PROC_BROKER_ORDERS_AND_MOVEMENTS, 'selectContract');
    }

    setSelectedOption(selectedOption) {
        this.setState({
            selectedOption
        });
        this.props.selectedOptionChanged(selectedOption);
    }

    buildOldVersion() {
        const { immJointContracts, immOrdersAndMovements, flagBasedFeatures } = this.props;
        const contractId = this.state.selectedContract;
        const immContract = immJointContracts.getIn(['byId', contractId]);
        const { planId } = this.props.match.params;

        return (
            <BrokerOrdersAndMovementsConsult
                immJointContracts={immJointContracts}
                immOrdersAndMovements={immOrdersAndMovements}
                selectedContract={contractId}
                selectedOption={this.state.selectedOption}
                immContract={immContract}
                setSelectedContract={this.setSelectedContract}
                setSelectedOption={this.setSelectedOption}
                planId={planId}
                immFeatureFlag={flagBasedFeatures}
            />
        )
    }

    buildNewVersion() {
        const { immJointContracts, immOrdersAndMovements, flagBasedFeatures, immValues, immBrokerMyInvestments } = this.props;
        const contractId = this.state.selectedContract;
        const contractList = immOrdersAndMovements.get('contractList');
        let immOrdersAndMovementsWithCrypto;
        let immContract;

        if (contractList && contractList.get('crypto')) {
            immOrdersAndMovementsWithCrypto = addCryptoContracts(contractList, immJointContracts);
            immContract = immOrdersAndMovementsWithCrypto.getIn(['byId', contractId]);
        } else {
            immContract = immJointContracts.getIn(['byId', contractId]);
        }

        const { planId } = this.props.match.params;
        const fetchingContractList = immOrdersAndMovements.get('fetchingContractList');
        const successContractList = immOrdersAndMovements.get('successContractList');
        const fetchingPGData = immBrokerMyInvestments.get('isFetching');
        if (fetchingContractList || fetchingPGData) {
          return <LoadingSection />;
        } else if (!fetchingContractList && successContractList && contractList) {
          return (
            <BrokerOrdersAndMovementsNewView
              immJointContracts={immJointContracts}
              immOrdersAndMovements={immOrdersAndMovements}
              selectedContract={contractId}
              selectedOption={this.state.selectedOption}
              immContract={immContract}
              setSelectedContract={this.setSelectedContract}
              setSelectedOption={this.setSelectedOption}
              planId={planId}
              immFeatureFlag={flagBasedFeatures}
              contractList={contractList}
            />
          );
        }
    }

    render() {
        const {
            clearActivityFilter,
            clearMovementsFilter,
            getContractActivities,
            getContractValues,
            getCryptoContractValues,
            applyCryptoFilter,
            clearCryptoFilters,
            getNextMovementPage,
            getRejectedActivities,
            getValueMovements,
            immContractActivities,
            immJointContracts,
            immOrdersAndMovements,
            immRejectedActivities,
            immValueMovements,
            immValues,
            setActivityFilter,
            setMovementsFilter,
            validateAndExecuteSagas,
            flagBasedFeatures,
            getNewFundMovements
        } = this.props;
        const { planId } = this.props.match.params;
        const contractId = this.state.selectedContract;
        const mappingBreadcrumb = this.getBreadcrumbData();
        const ffContribution = flagBasedFeatures.get('wealth_funds_periodic_contributions');
        let activityBlock;
        let movementsBlock;
        let tabs;
        let updatedImmJointContracts = immJointContracts;
        const contractList = immOrdersAndMovements.get('contractList');
        if (contractList && contractList.get('crypto')) {
            updatedImmJointContracts = immJointContracts.update('byId', byId => {
              return byId.merge(
                Map(
                  contractList.get('crypto').reduce((acc, cryptoItem) => {
                    const id = cryptoItem.get ? cryptoItem.get('id') : cryptoItem.id;
                    if (id) {
                      acc[id] = cryptoItem;
                    };

                    return acc;
                  }, {})
                )
              );
            });
          }
        const immContract = updatedImmJointContracts?.getIn(['byId', contractId]);

        if (immContract && (immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE || immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO)) {
            activityBlock = (
                <BrokerOrdersAndMovementsActivity
                    immContract={immContract}
                    immActivities={immContractActivities}
                    getContractActivities={getContractActivities}
                    immRejectedActivities={immRejectedActivities}
                    getRejectedActivities={getRejectedActivities}
                    setFilter={setActivityFilter}
                    clearFilter={clearActivityFilter}
                    flagBasedFeatures={flagBasedFeatures}
                    immOrdersAndMovements={immOrdersAndMovements}
                    getNewFundMovements={getNewFundMovements}
                />
            );

            movementsBlock = (
                <BrokerOrdersAndMovementsMovementsTab
                    immValues={immValues}
                    immContract={immContract}
                    immValueMovements={immValueMovements}
                    getNextMovementPage={getNextMovementPage}
                    getContractValues={getContractValues}
                    getCryptoContractValues={getCryptoContractValues}
                    applyCryptoFilter={applyCryptoFilter}
                    clearCryptoFilters={clearCryptoFilters}
                    getValueMovements={getValueMovements}
                    setFilter={setMovementsFilter}
                    clearFilter={clearMovementsFilter}
                />
            );

            //Se agrega la propiedad titles que provee un titulo distinto para cada tab.
            //El flag dynamicTitle debe ser true para que el componente tome la propiedad titles en lugar de title.
            tabs = (
                <TabbedContentBox
                    title=""
                    dynamicTitle
                    titles={[
                        formatText('broker-ordersAndMovementsMovementsTabSelectedContractActivity'),
                        formatText('broker-ordersAndMovementsMovementsTabSelectedMovements')
                    ]}
                    tabComponents={[activityBlock, movementsBlock]}
                    tabLabels={[
                        formatText('broker-ordersAndMovementsOrdersTab'),
                        formatText('broker-ordersAndMovementsMovementsTab')
                    ]}
                    tabsAsPills={true}
                />
            );
        } else if (immContract) {
            if (this.state.selectedOption) {
                let title;

                if (
                    this.state.selectedOption.value ===
                    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING
                ) {
                    title = formatText('broker-ordersAndMovementsFundsPendingMovements');
                } else if (
                    this.state.selectedOption.value ===
                    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED && !ffContribution
                ) {
                    title = formatText('broker-ordersAndMovementsFundsConsolidatedMovements');
                } else if (
                    this.state.selectedOption.value ===
                    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED && ffContribution
                ) {
                    title = formatText('broker-ordersAndMovementsFundsTitle');
                } else if (
                    this.state.selectedOption.value ===
                    BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED
                ) {
                    title = formatText('broker-ordersAndMovementsFundsCanceledMovements');
                } else if (
                    this.state.selectedOption.value === BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC
                ) {
                    title = formatText(
                        'broker-ordersAndMovementsMovementsPlanPeriodicContributions'
                    );
                } else if (
                    this.state.selectedOption.value === BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER
                ) {
                    title = formatText('broker-ordersAndMovementsSelectedPlanMovements');
                } else {
                    title = formatText('broker-ordersAndMovementsMovementsPendingOrders');
                }

                tabs = (
                    <OKSectionBox title={title}>
                        <BrokerOrdersAndMovementsActivity
                            immContract={immContract}
                            immActivities={immContractActivities}
                            getContractActivities={getContractActivities}
                            immRejectedActivities={immRejectedActivities}
                            getRejectedActivities={getRejectedActivities}
                            selectedOption={this.state.selectedOption}
                            setFilter={setActivityFilter}
                            clearFilter={clearActivityFilter}
                            flagBasedFeatures={flagBasedFeatures}
                            immOrdersAndMovements={immOrdersAndMovements}
                            getNewFundMovements={getNewFundMovements}
                        />
                    </OKSectionBox>
                );
            } else if (immContract.get('type') === BROKER_JOINT_CONTRACTS_FUTURES) {
                const {
                    clearFilter,
                    downloadAccountsTransactions,
                    flagBasedFeatures,
                    immAccountsTransactions,
                    requestAccountTransactions,
                    requestNextAccountTransactionsPage,
                    resetFilter,
                    setFilter,
                } = this.props;
                const accountId = immJointContracts.getIn([
                    'byId',
                    this.state.selectedContract,
                    'accountId'
                ]);
                tabs = (
                    <AccountLastMovements
                        accountId={accountId}
                        clearFilter={clearFilter}
                        downloadAccountsTransactions={downloadAccountsTransactions}
                        flagBasedFeatures={flagBasedFeatures}
                        immAccountsTransactions={immAccountsTransactions}
                        isCredit={false}
                        requestAccountTransactions={requestAccountTransactions}
                        requestNextAccountTransactionsPage={requestNextAccountTransactionsPage}
                        resetFilter={resetFilter}
                        setFilter={setFilter}
                        validateAndExecuteSagas={validateAndExecuteSagas}
                    />
                );
            } else if(immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND && ffContribution) {

                const params = {
                    "label": formatText(
                        'broker-ordersAndMovementsConsultSelectOptionConsolidated'
                    ),
                    "value": BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED
                }
                this.setSelectedOption(params)
                tabs = (
                    <OKSectionBox>
                        <BrokerOrdersAndMovementsActivity
                            immContract={immContract}
                            immActivities={immContractActivities}
                            getContractActivities={getContractActivities}
                            immRejectedActivities={immRejectedActivities}
                            getRejectedActivities={getRejectedActivities}
                            selectedOption={params}
                            setFilter={setActivityFilter}
                            clearFilter={clearActivityFilter}
                            flagBasedFeatures={flagBasedFeatures}
                            immOrdersAndMovements={immOrdersAndMovements}
                            getNewFundMovements={getNewFundMovements}

                        />
                    </OKSectionBox>
                );
            }
        }

        const content = flagBasedFeatures.get(INVESTMENT_CONTRACTS_CANCELLED)
          ? this.buildNewVersion()
          : this.buildOldVersion();

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('broker-ordersAndMovementsViewTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12">
                                {content}
                            </div>
                            <div className="col-xs-12 grid-view--fix-cell-separation">
                                {tabs}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerOrdersAndMovementsView.propTypes = {
    clearActivityFilter: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    clearMovementsFilter: PropTypes.func.isRequired,
    downloadAccountsTransactions: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getContractActivities: PropTypes.func.isRequired,
    getContractValues: PropTypes.func.isRequired,
    getRejectedActivities: PropTypes.func.isRequired,
    getValueMovements: PropTypes.func.isRequired,
    getNextMovementPage: PropTypes.func.isRequired,
    immAccounts: PropTypes.object,
    immAccountsTransactions: PropTypes.object,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immContractActivities: PropTypes.object.isRequired,
    immJointContracts: PropTypes.object.isRequired,
    immOrdersAndMovements: PropTypes.object.isRequired,
    immRejectedActivities: PropTypes.object.isRequired,
    immValueMovements: PropTypes.object.isRequired,
    immValues: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    requestAccountTransactions: PropTypes.func.isRequired,
    requestNextAccountTransactionsPage: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    selectedOptionChanged: PropTypes.func.isRequired,
    setActivityFilter: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    setMovementsFilter: PropTypes.func.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
}

module.exports.constructor = BrokerOrdersAndMovementsView;
module.exports.BrokerOrdersAndMovementsView = withRouter(connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immAccountsTransactions: state.accountsTransactions,
        immContractActivities: state.brokerContractActivities,
        immJointContracts: state.brokerJointContracts,
        immOrdersAndMovements: state.brokerOrdersAndMovements,
        immRejectedActivities: state.brokerContractRejectedActivities,
        immValueMovements: state.brokerValueMovements,
        immValues: state.brokerContractValues,
        immBrokerMyInvestments: state.brokerMyInvestments,
    }), {
        clearActivityFilter,
        clearFilter: accountsTransactionsActions.clearAccountTransactionsFilter,
        clearMovementsFilter,
        downloadAccountsTransactions: accountTransactionsDownloadActions.downloadAccountsTransactions,
        fetchMyInvestments,
        getContractActivities,
        getContractValues: getAllContractValues,
        getCryptoContractValues: getAllCryptoContractValues,
        getRejectedActivities,
        getValueMovements,
        getNextMovementPage: brokerValueMovementsActions.getNextMovementPage,
        applyCryptoFilter: applyCryptoFilter,
        clearCryptoFilters: clearCryptoFilters,
        requestAccountTransactions: accountsTransactionsActions.requestAccountTransactions,
        requestNextAccountTransactionsPage: accountsTransactionsActions.requestNextAccountTransactionsPage,
        reset,
        resetFilter: accountsTransactionsActions.resetAccountTransactionFilter,
        selectedOptionChanged,
        setActivityFilter,
        setFilter: accountsTransactionsActions.setAccountTransactionsFilter,
        setMovementsFilter,
        validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
        getNewFundMovements,
        fetchContractList: brokerOrdersAndMovementsActions.fetchContractList,
    }
)(BrokerOrdersAndMovementsView));
